import React from 'react';
import {
  HeadTitle,
  Spacer,
  Explain,
  ExplainItem,
  TheFooter,
  Button,
  Popup,
  CheckboxBottomsheet,
} from 'oui';
import { SideBox, BannerBox, FloatingBox } from '../etc/LBox/LBox';
import TermFullSheet from '../feedback/TermFullSheet/TermFullSheet';
import useNotiPreReg from '../../application/bloc/useNotiPreReg';
import useFooter from '../../application/hooks/useFooter';
import StackingSnackbar from '../component/StackingSnackbar/StackingSnackbar';

const NotiPreReg = () => {
  const {
    isLoading,
    isMonthlyRequestCompleted,
    hasPromotion,
    buttonText,
    popup,
    BANNER,
    EXPLAIN,

    termBottomsheet,
    termFullsheet,
    openTermFullsheet,

    ctaEvent,
    submitEvent,
  } = useNotiPreReg();

  const { navigateOvertake, navigateOvertakePrivacy } = useFooter();

  const checkList = termBottomsheet.checkList.map((item) => ({
    isExpand: item.isExpand,
    checked: item.checked,
    text: item.text,
    icon: true,
    subTextItem: item.subTextItem,
  }));

  return (
    <>
      <StackingSnackbar bottom={120} />
      {!isLoading && (
        <>
          <HeadTitle
            textTitle={'매월 자동으로\n 대출 심사 결과를 받아보세요'}
          />
          <Spacer size={'xs'} />

          <SideBox>
            <Explain
              children={EXPLAIN.map((item: any) => {
                return (
                  <ExplainItem
                    key={item.title}
                    title={item.title}
                    subTitle={item.subTitle}
                    avatar={{ source: item.source, alt: item.alt }}
                  />
                );
              })}
            />
          </SideBox>

          {hasPromotion ? (
            <>
              <Spacer size={'lg'} />
              <BannerBox>
                <img src={BANNER} alt={'noti-banner'} />
              </BannerBox>
              <Spacer size={'lg'} />
              <Spacer size={'lg'} />
            </>
          ) : (
            <div style={{ height: '200px' }} />
          )}

          <TheFooter
            type={'d'}
            onClickOvertake={navigateOvertake}
            onClickOvertakePrivacy={navigateOvertakePrivacy}
          />

          <FloatingBox>
            <Button
              flexible={true}
              isDisabled={isMonthlyRequestCompleted}
              configuration={'contained'}
              children={buttonText}
              state={!isMonthlyRequestCompleted ? 'enabled' : 'disabled'}
              onClick={ctaEvent}
            />
          </FloatingBox>
        </>
      )}

      <Popup
        isPopupOpen={popup.open}
        title={popup.message}
        confirmBtn={{ text: '확인', onClick: () => {} }}
      />

      <CheckboxBottomsheet
        isOpenCheckBottomsheet={termBottomsheet.isOpen}
        title={'정기 알림 서비스 신청에 필요한\n 약관을 확인해주세요'}
        buttonText={'동의하고 대출 심사 진행하기'}
        buttonState={termBottomsheet.isActive ? 'enabled' : 'disabled'}
        buttonIsDisabled={!termBottomsheet.isActive}
        checkboxItems={checkList}
        onClickCheck={(idx: number) => termBottomsheet.toggleCheckBox(idx)}
        onClickExpand={openTermFullsheet}
        onClickElementLabel={openTermFullsheet}
        onClickSubmitButton={submitEvent}
        onCloseCheckBottomsheet={termBottomsheet.close}
        toast={''}
      />

      <TermFullSheet
        isOpen={termFullsheet.isOpen}
        title={termFullsheet.title}
        path={termFullsheet.path}
        onClickClose={termFullsheet.close}
      />
    </>
  );
};

export default NotiPreReg;
